import { httpService } from 'core-utilities';
import peopleListModule from '../peopleListModule';

function productExperimentationService(resources) {
  'ngInject';

  const { friendsExperimentationUrlConfig } = resources;
  return {
    getFriendsExperimentationValues(values) {
      const data = {
        parameters: values.join(',')
      };
      return httpService.get(friendsExperimentationUrlConfig, data);
    }
  };
}

peopleListModule.factory('productExperimentationService', productExperimentationService);

export default productExperimentationService;
